import { render, staticRenderFns } from "./ajout-medicament.html?vue&type=template&id=988980fc&scoped=true&external"
import script from "./ajout-medicament.js?vue&type=script&lang=js&external"
export * from "./ajout-medicament.js?vue&type=script&lang=js&external"
import style0 from "./ajout-medicament.scss?vue&type=style&index=0&id=988980fc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988980fc",
  null
  
)

export default component.exports